<template>
  <div>
    <SubSideMenu
      :subsection="'SiteTrack'"
      :options="options"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import SubSideMenu from "@/components/SideMenu/SubSideMenu/SubSideMenu.vue"

export default {
  name: "SiteTrackSideBar",
  components: {
    SubSideMenu
  },
  computed: {
    ...mapGetters(["siteTrackNav", "getUserPermissions"]),
    options() {
      return this.siteTrackNav
    },
    siteTrackPermissions() {
      return this.getUserPermissions.site_track
    }
  }
}
</script>